import { defineComponent as V, computed as G, toValue as C, createBlock as d, openBlock as r, resolveDynamicComponent as h, mergeProps as P, unref as o, withCtx as a, createElementBlock as u, createCommentVNode as s, createElementVNode as v, normalizeClass as i, createTextVNode as f, renderSlot as t, toDisplayString as n, createVNode as y } from "vue";
import l from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Form/form.js";
import c from "../../helpers/PassThrough.vue2.js";
import { useOUIAProps as g } from "../../helpers/ouia.js";
import F from "./FormHelperText.vue2.js";
import T from "../HelperText/HelperText.vue2.js";
import $ from "../HelperText/HelperTextItem.vue2.js";
import { isDefined as L } from "../../node_modules/.pnpm/@vueuse_shared@13.1.0_vue@3.5.13_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
import { provideChildrenTracker as N } from "../../use/children-tracker.js";
import { FormGroupInputsKey as S } from "./common.js";
const q = ["for"], j = /* @__PURE__ */ V({
  name: "PfFormGroup",
  __name: "FormGroup",
  props: {
    fieldset: { type: Boolean },
    label: {},
    labelInfo: {},
    required: { type: Boolean },
    validated: {},
    inline: { type: Boolean },
    stack: { type: Boolean },
    noPaddingTop: { type: Boolean },
    helperText: {},
    helperTextVariant: { default: "default" },
    helperTextBeforeField: { type: Boolean },
    helperTextInvalid: {},
    fieldId: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(I) {
    const p = I, k = g({ id: p.ouiaId, safe: p.ouiaSafe }), B = N(S), b = G(() => {
      if (L(p.validated))
        return p.validated;
      for (const e of ["error", "warning", "success", "default"])
        if (B.some((m) => C(m) === e))
          return e;
      return "default";
    });
    return (e, m) => (r(), d(h(e.fieldset ? "fieldset" : "div"), P(o(k), {
      class: o(l).formGroup
    }), {
      default: a(() => [
        e.label || e.$slots.label ? (r(), u("div", {
          key: 0,
          class: i([o(l).formGroupLabel, {
            [o(l).modifiers.info]: e.labelInfo || e.$slots["label-info"],
            [o(l).modifiers.noPaddingTop]: e.noPaddingTop
          }])
        }, [
          (r(), d(h(e.labelInfo || e.$slots["label-info"] ? "div" : c), {
            class: i(o(l).formGroupLabelMain)
          }, {
            default: a(() => [
              v("label", {
                class: i(o(l).formLabel),
                for: e.fieldId
              }, [
                v("span", {
                  class: i(o(l).formLabelText)
                }, [
                  t(e.$slots, "label", {}, () => [
                    f(n(e.label), 1)
                  ])
                ], 2),
                e.required ? (r(), u("span", {
                  key: 0,
                  class: i(o(l).formLabelRequired),
                  "aria-hidden": "true"
                }, n(" *"), 2)) : s("", !0)
              ], 10, q),
              m[0] || (m[0] = f(" " + n(" ") + " ")),
              t(e.$slots, "label-icon")
            ]),
            _: 3
          }, 8, ["class"])),
          e.labelInfo || e.$slots["label-info"] ? (r(), u("div", {
            key: 0,
            class: i(o(l).formGroupLabelInfo)
          }, [
            t(e.$slots, "label-info", {}, () => [
              f(n(e.labelInfo), 1)
            ])
          ], 2)) : s("", !0)
        ], 2)) : s("", !0),
        v("div", {
          class: i([o(l).formGroupControl, {
            [o(l).modifiers.inline]: e.inline,
            [o(l).modifiers.stack]: e.stack
          }])
        }, [
          e.helperTextBeforeField ? s("", !0) : t(e.$slots, "default", { key: 0 }),
          b.value === "error" && e.helperTextInvalid || e.$slots["helper-text-invalid"] || e.helperText || e.$slots["helper-text"] ? (r(), d(F, {
            key: 1,
            id: `${e.fieldId}-helper`
          }, {
            default: a(() => [
              (e.helperTextInvalid || e.$slots["helper-text-invalid"]) && b.value === "error" ? (r(), d(T, { key: 0 }, {
                default: a(() => [
                  t(e.$slots, "helper-text-invalid", {}, () => [
                    y($, {
                      icon: "",
                      variant: "error"
                    }, {
                      default: a(() => [
                        f(n(e.helperTextInvalid), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 3
              })) : (r(), d(T, { key: 1 }, {
                default: a(() => [
                  t(e.$slots, "helper-text", {}, () => [
                    y($, {
                      icon: e.helperTextVariant !== "default",
                      variant: e.helperTextVariant
                    }, {
                      default: a(() => [
                        f(n(e.helperText), 1)
                      ]),
                      _: 1
                    }, 8, ["icon", "variant"])
                  ])
                ]),
                _: 3
              }))
            ]),
            _: 3
          }, 8, ["id"])) : s("", !0),
          e.helperTextBeforeField ? t(e.$slots, "default", { key: 2 }) : s("", !0)
        ], 2)
      ]),
      _: 3
    }, 16, ["class"]));
  }
});
export {
  j as default
};
